import React, { useRef } from 'react'
import { useEditUserAppMutation } from './UnitSlice'

function UnitEdit({ refOpen, editData, setEditData }) {

    const refCloseDriver = useRef(null)

    const [editUserApp, { isLoading }] = useEditUserAppMutation();

    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value })
    }

    const handleClick = async (e) => {
        e.preventDefault()
        try {
            console.log("editData?.active", editData?.active)

            const a = await editUserApp({ id: editData?.id, name: editData?.name, active: Number(editData?.active), })
            console.log(a)
            refCloseDriver.current.click();
            setEditData({ name: "", active: "" });
        }
        catch (e) {
            console.error("Error in community edit", e)
        }
    }

    return (
        <>
            <button ref={refOpen} type="button" className="btn d-none" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas1" aria-controls="depOffCanvas1"></button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="depOffCanvas1" aria-labelledby="depOffCanvas1">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Unit</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refCloseDriver}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={editData?.name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>

                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Active
                                </label>
                                <select className="form-select"
                                    value={editData?.active}
                                    onChange={handleChange}
                                    id="active" name="active" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnitEdit